import React from 'react'
import { AppDownloadBannerContentType } from './types'
import useMobilePromobarsExperiment from '@/hooks/useMobilePromobarsExperiment'
import AppBanner from '.'
import useAppBanner from './useAppBanner'

const AppBannerAboveHeaderWithExperiment = ({
  content
}: {
  content: AppDownloadBannerContentType
}) => {
  const showAppBanner = useAppBanner()
  const isMobilePromoSETI = useMobilePromobarsExperiment()

  const showAppBannerAboveHeader = !isMobilePromoSETI

  return showAppBanner && showAppBannerAboveHeader ? (
    <AppBanner content={content} />
  ) : null
}

export default AppBannerAboveHeaderWithExperiment
